import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './RecordLabelNav.style.css';

const RecordLabelNav = ({ links }) => {
  return (
    <Fragment>
      <Container className='RecordLabelNav text-capitalize '>
        <Row>
          <Col md={4}>
            <NavLink to='/' className='RecordLabelNav-Brand'>
              Record Label
            </NavLink>
          </Col>
          <Col className='d-flex record_nav_links'>
            <div className={links}>
              <NavLink activeClassName='active ' to='/recordLabel'>
                release
              </NavLink>
            </div>
            <div className={links}>
              <NavLink activeClassName='active' to='/artist'>
                artist
              </NavLink>
            </div>
            <div className={links}>
              <NavLink activeClassName='active' to='/submission'>
                submission
              </NavLink>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

RecordLabelNav.defaultProps = {
  links: 'text-center py-1',
};
RecordLabelNav.propTypes = {
  links: PropTypes.string.isRequired,
};
export default RecordLabelNav;
